<script lang="ts">
    import { Navigation } from '../../utilities/Navigation';
    import { fade } from 'svelte/transition';
    import { blur } from 'svelte/transition';
    import { get } from 'svelte/store';
    import { _ } from 'svelte-i18n';

    import {
        TacticalPlanApi,
        TacticalPlanRequestSchema,
        type TacticalPlanResponseType,
    } from './TacticalPlanApi';    import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
    import MessageNotFound from '../../shared/Messages/MessageNotFound.svelte';
    import MessageDanger from '../../shared/Messages/MessageDanger.svelte';
    import TacticalPlanListItem from './TacticalPlanListItem.svelte';
    import Spinner from '../../shared/Spinner/Spinner.svelte';
    import { filter } from '../../../stores/filter';
    import { api } from '../../../stores/api';
    import TemplateInner from '../../shared/TemplateInner.svelte';
    import { week } from '../../utilities/mockWeekSchedule';
    import { TacticalPlan } from './TacticalPlan';

    export let tacticalPlans: TacticalPlan[] = [];
    export let reloadElements: () => void;
    export let onUpdateOne: (updatedPlans?: TacticalPlanResponseType[]) => void;

    export let loading: boolean = true;

    export let disableChanging: boolean = false;

    let error: string = '';
    let clickedTacticalPlanId: number = -1;

    function onCloneTacticalPlan(tacticalPlan: TacticalPlanResponseType) {
        if (tacticalPlan.id) {
            Promise.all([TacticalPlanApi.deepcopy(get(api), tacticalPlan.id)]).then(([res]) => {
                // tacticalPlans = [...tacticalPlans, res]
                tacticalPlans = [...tacticalPlans, new TacticalPlan(res)];
                Navigation.navigate('/tactical-plan/' + res.id);
            });
        } else {
            throw new Error('Tactical plan id is not defined');
        }
    }

    $: console.log('TacticalPlanList', tacticalPlans.length);
    $: allTacticalPlansRaw = tacticalPlans
        .map(tp => tp._get())
        .filter((tp): tp is TacticalPlanResponseType => tp !== null);
</script>

{#if loading}
    <Spinner />
{:else}
    {#if error}
        <div out:blur>
            <MessageDanger {error} />
        </div>
    {/if}
    {#if tacticalPlans.length === 0}
        <div in:fade|global={{ delay: 2000, duration: 1000 }}>
            <TemplateInner>
                <MessageNotFound text={$_('Not found any plan')} />
            </TemplateInner>
        </div>
    {:else}
        {#each tacticalPlans as tacticalPlan, index (tacticalPlan?.getId())}
            {#if tacticalPlan}
                <div out:blur>
                    <TacticalPlanListItem
                        showHeader={index === 0}
                        bind:clickedTacticalPlanId
                        bind:disableChanging
                        willBeNextItem={index < tacticalPlans.length - 1}
                        bind:tacticalPlan
                        bind:error
                        {onUpdateOne}
                        {onCloneTacticalPlan}
                        allTacticalPlans={allTacticalPlansRaw}
                        on:click={() => {
                            Navigation.navigate('/tactical-plan/' + tacticalPlan.getId());
                        }}
                    />
                </div>
            {/if}
        {/each}
        <div class="week-schedule-legend">
            {#each week as day, index}
                {#if day.id === 128}
                    <span class="holiday-color" style={day.style}
                        >{$_(day.translationShort).substring(0, 2)}</span
                    >
                    <span>- {$_('holiday_description')}</span>
                {/if}
            {/each}
        </div>
    {/if}
{/if}

<style>
    .week-schedule-legend {
        margin-top: 6px;
        text-align: right;
        color: var(--list-element-header-color-inactive);
        font-size: var(--list-element-header-font-size);
    }
    .holiday-color {
        text-transform: capitalize;
        /*opacity: 0.5;*/
    }
</style>
